



































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import Appconst from '../../../lib/appconst';
@Component({
    name:'scientficProjectAdd'
})
export default class ScientficProjectAdd extends AbpBase  {
    @Prop() editData:Object;
    initData:any = {
        formData: {
            attachs:[]
        },
        dicData: {
            researchProjectCatalog: []
        },
        fileUrl: Appconst.fileUrl,  //附件上传地址
        defaultList:[],//编辑时候已经上传的附件
        disabled:false,
    }
    //附件上传成功
    fileSuccess(res:any){
        this.initData.formData.attachs.push(res.result);
    }
    //附件上传失败
    fileRemove(res:any){
        if(res.response){
           Ajax.post('/api/File/DeleteTempFile?fileName='+res.response.result)
            this.initData.formData.attachs.splice(this.initData.formData.attachs.indexOf(res.response.result),1); 
        }
    }
    //提交
    async Submit(type:any) {
        console.log(type);
        (this.$refs.addForm as any).validate(async (valid:boolean)=>{
            if(valid){
                this.initData.formData.ratifyYear = new Date(this.initData.formData.ratifyDt).getFullYear();
                if(type === 'add'){
                    await Ajax.post('/api/services/app/ResearchProject/CreateCXProjectAsync', this.initData.formData);    
                    this.$Modal.success({
                        title: '创新引导项目登记',
                        content: '项目信息已提交，待审核后可成功登记！',
                        onOk: ()=>{
                            this.$router.push({name: 'specialProjectList'})
                        }
                    })
                }else{
                    await Ajax.put('/api/services/app/ResearchProject/UpdateCXProjectAsync', this.initData.formData).then( () => {
                        this.$Message.success('修改成功!');
                        (this as any).$parent.$parent.initData.modalData.status = false; 
                    } ).catch( () => {
                        (this as any).$parent.$parent.initData.modalData.loading = false; 
                        this.$nextTick( ()=>{
                            (this as any).$parent.$parent.initData.modalData.loading = true; 
                        } );
                    });      
                }
                (this as any).$parent.$parent.GetData();
            }else{
                (this as any).$parent.$parent.resetMonthLoading();
            }
        })
    }
    //获取合同信息
    GetContactInfo(type:number) {
        let code:any = null,
            keyName:any;
        if(type == 1){
            code = this.initData.formData.contractCode;
            keyName = 'contractName';
        }else{
            code = this.initData.formData.externalContractCode;
            keyName = 'externalContractName';
        }
        if(!code){
            this.initData.formData[keyName] = null;
            return;
        };
        Ajax.get('/api/services/app/Contract/GetContractByCodeAsync?ContractCode='+code).then((res:any)=>{
            // if(!res.data.result){
            //     this.$Message.error('合同编号错误!');
            //     return;
            // };
            console.log(res.result);
            if(!res.result) return;
            this.initData.disabled = false;
            //合同信息
            this.$set(this.initData.formData, keyName, res.data.result.contractName);  
            this.$set(this.initData.formData, 'projectName', res.data.result.contractName);
            this.$set(this.initData.formData,'contractAmount',res.data.result.contractAmount);
            this.$set(this.initData.formData,'beginDt',res.data.result.beginDt);
            this.$set(this.initData.formData,'endDt',res.data.result.endDt);
            this.$set(this.initData.formData,'trusteeshipDepId',res.data.result.belongOrgId);
            this.$set(this.initData.formData,'projectLeaderId',res.data.result.contractProjectLeaderId);
            this.$set(this.initData.formData,'projectLeaderTell',res.data.result.contractProjectLeader.phoneNumber);
        })
    }
    //重置弹窗
    ResetForm() {
        (this as any).$refs.addForm.resetFields();
        this.initData.formData = {}
    }
    async GetDic() {
        await this.$store.dispatch('project/GetResearchProjectCatalog');
        await this.$store.dispatch('project/GetAllUser');
        await this.$store.dispatch('project/GetbearerOrg');
        this.initData.dicData.researchProjectCatalog = this.$store.state.project.researchProjectCatalog;
        //合同签订人查询特殊接口
        await this.$store.dispatch({type: 'project/GetAllPersonNoPermission'});
        this.initData.dicData.allPersonNoPermission = this.$store.state.project.allPersonNoPermission;
        this.initData.dicData.userList = this.$store.state.project.userList;
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
    }
    //验证规则
    rules:any = {
        // contractCode: [{ required: true, message: '请填写合同编号', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请填写项目编号', trigger: 'blur' }],
        projectName: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
        projectLeaderId: [{ required: true, type: 'number', message: '请选择项目负责人', trigger: 'change' }],
    }
    mounted() {
        this.GetDic();
    }

    //编辑弹窗
    //更新数据
    @Watch('editData')
    editDataChange(newVal:any, oldVal:any){
        let tempVal = newVal;
        tempVal.projectCatalogId = tempVal.projectCatalog ? tempVal.projectCatalog.id : undefined;
        tempVal.executeLeaderId = tempVal.executeLeader ? tempVal.executeLeader.id : undefined;
        tempVal.projectLeaderId = tempVal.projectLeader ? tempVal.projectLeader.id : undefined;
        tempVal.trusteeshipDepId = tempVal.trusteeshipDep ? tempVal.trusteeshipDep.id : undefined;
        tempVal.ratifyDt = tempVal.projectCatalog ? new Date(new Date().setFullYear(tempVal.ratifyYear)) : undefined;
        tempVal.projectLeaderTell = tempVal.projectLeader.phoneNumber?tempVal.projectLeader.phoneNumber:'';
        console.log(tempVal)
        if(tempVal.attachs.length){
            this.initData.defaultList = [];
            tempVal.attachs.forEach((item:any,index:any) => {
               this.initData.defaultList.push({
                   name:item.attachName,
                   url:item.url
                }); 
            });
        }
        this.initData.disabled = false;
        this.initData.formData = Object.assign({},tempVal);
        this.initData.formData.attachs = [];
    }
}
